import React from "react";
import styled, { keyframes } from "styled-components";

// Keyframes for sliding animations
const slideLeft = keyframes`
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
`;

const slideRight = keyframes`
  0% { transform: translateX(-50%); }
  100% { transform: translateX(0); }
`;

// Wrapper
const SliderWrapper = styled.div`
  overflow: hidden;
  width: 100%;
  background: #f9f9f9;
  padding: 20px 0;
`;

// Row container
const Row = styled.div`
  display: flex;
  width: 200%; /* double width for looping */
  animation: ${({ direction }) => (direction === "left" ? slideLeft : slideRight)}
    20s linear infinite;
`;

// Single logo
const Logo = styled.img`
  height: 60px;
  margin: 0 40px;
  object-fit: contain;
  filter: grayscale(100%);
  transition: filter 0.3s ease;

  &:hover {
    filter: grayscale(0%);
  }
`;

const ClientsSlider = () => {
  const logos = [
    "https://upload.wikimedia.org/wikipedia/commons/a/ab/Apple-logo.png",
    "https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg",
    "https://upload.wikimedia.org/wikipedia/commons/0/08/Google_Logo.svg",
    "https://upload.wikimedia.org/wikipedia/commons/5/51/Facebook_f_logo_%282019%29.svg",
    "https://upload.wikimedia.org/wikipedia/commons/2/2f/Instagram_logo.svg",
  ];

  return (
    <SliderWrapper>
      {/* First Row (Left to Right) */}
      <Row direction="right">
        {logos.concat(logos).map((logo, index) => (
          <Logo key={index} src={logo} alt={`client-${index}`} />
        ))}
      </Row>

      {/* Second Row (Right to Left)  */}
      <Row direction="left">
        {logos.concat(logos).map((logo, index) => (
          <Logo key={index} src={logo} alt={`client-${index}`} />
        ))}
      </Row> 
    </SliderWrapper>
  );
};

export default ClientsSlider;
